import styled from 'styled-components';

export const OuterContainer = styled.div`
  width: 100%;
  position: relative;
  align-items: flex-start;
  background-color: var(--white);
  display: flex;
  flex-direction: row;
`;

export const MainContainer = styled.div`
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 48px);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 24px 32px 16px;
  border-bottom: 1px solid var(--color-neutral-alpha-90, #c9c6cc80);

  @media (max-width: 765px) {
    padding: 20px 16px 14px;
    flex-direction: column;
  }
`;

export const HeaderTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h2`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 24px;
  font-weight: 600;
  color: var(--text);
  margin: 0;
`;

export const SubTitle = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 13px;
  color: #6b6472;
  margin: 0;
`;

export const Content = styled.div`
  padding: 20px 32px 44px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 765px) {
    padding: 16px 16px 28px;
  }
`;

export const Tabs = styled.div`
  display: inline-flex;
  padding: 6px;
  gap: 8px;
  border-radius: 999px;
  background: #f2f1f3;
  width: fit-content;
`;

export const TabButton = styled.button`
  border: none;
  background: ${(props) => (props.isActive ? '#7200E0' : 'transparent')};
  color: ${(props) => (props.isActive ? '#ffffff' : '#5a5561')};
  padding: 8px 18px;
  border-radius: 999px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ControlsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ControlCard = styled.div`
  background: #f8f8f9;
  border: 1px solid #ddd9e3;
  border-radius: 12px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 765px) {
    padding: 14px;
  }
`;

export const ControlHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

export const ControlTitle = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 15px;
  font-weight: 500;
  color: var(--text);
  line-height: 1.25;

  @media (max-width: 765px) {
    font-size: 14px;
  }
`;

export const ControlValue = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 13px;
  font-weight: 600;
  color: #7200e0;
`;

export const ControlDescription = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 13px;
  color: #6f6a76;
`;

export const SliderInput = styled.input`
  width: 100%;
  appearance: none;
  height: 6px;
  border-radius: 999px;
  background: #e5e3e8;
  outline: none;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #7200e0;
    border: 3px solid #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #7200e0;
    border: 3px solid #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SliderStops = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(42px, 1fr));
  gap: 6px;
  align-items: center;
`;

export const SliderStop = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 11px;
  text-align: center;
  color: ${(props) => (props.isActive ? '#4b2a82' : '#9a94a3')};
`;

export const HelperText = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 13px;
  color: #5f5968;
  line-height: 1.3;

  @media (max-width: 765px) {
    font-size: 12px;
  }
`;

export const HelperRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const InfoIcon = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 999px;
  border: 1px solid #7d7788;
  color: #5f5968;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  margin-top: 1px;

  @media (max-width: 765px) {
    width: 14px;
    height: 14px;
    font-size: 10px;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const DependentToggles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 16px;
  border-left: 2px solid #ece9ef;

  @media (max-width: 765px) {
    padding-left: 12px;
  }
`;

export const ToggleLabelGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ToggleTitle = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
`;

export const ToggleDescription = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 12px;
  color: #6f6a76;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const PrimaryButton = styled.button`
  border: none;
  border-radius: 999px;
  padding: 10px 24px;
  background: #352982;
  color: #ffffff;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #2a1f67;
  }
`;

export const SecondaryButton = styled.button`
  border: 1px solid #c9c6cc;
  border-radius: 8px;
  padding: 8px 14px;
  background: #ffffff;
  color: #5a5561;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border 0.2s ease;
`;

export const NoticeCard = styled.div`
  border-radius: 12px;
  border: 1px dashed #d8c8f5;
  background: #fbf7fe;
  padding: 16px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  color: #4b2a82;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ClassesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ClassCard = styled.div`
  border: 1px solid var(--color-neutral-alpha-90, #c9c6cc80);
  border-radius: 12px;
  padding: 16px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ClassHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const ClassTitle = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
`;

export const EmptyState = styled.div`
  padding: 24px;
  border-radius: 12px;
  border: 1px dashed #d8d2df;
  color: #6f6a76;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
`;

export const OptionGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(
    ${(props) => Math.max(props.$count || 1, 1)},
    minmax(0, 1fr)
  );
  border: 1px solid #d8d1e5;
  border-radius: 7px;
  padding: 1px;
  background: #ece9ef;
  overflow: auto;

  @media (max-width: 765px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const OptionChip = styled.button`
  border: none;
  background: ${(props) => (props.isActive ? '#7200e0' : 'transparent')};
  color: ${(props) => (props.isActive ? '#ffffff' : '#34303b')};
  border-radius: 5px;
  padding: 10px 10px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  min-height: 36px;
  transition: background 0.2s ease, color 0.2s ease;

  @media (max-width: 765px) {
    font-size: 14px;
    min-height: 34px;
    padding: 8px 6px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;
